import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import * as yup from 'yup';
import InputWidget from './InputWidget';
import SubmissionFileUpload from '../../formik/SubmissionFileUpload';
import {FormattedMessage} from 'react-intl';

class LogoUploadWidget extends InputWidget {

    onFilesChanged = (files) => {
        if (files.length > 0) {
            this.props.formikProps.setFieldTouched(this.getFieldName(), true, false);
        }
        this.props.formikProps.setFieldValue(this.getFieldName(), files);
    };

    render() {
        return (
            <Form.Group>
                <Form.Label>{this.renderLabelText()}</Form.Label>
                <SubmissionFileUpload
                    onFilesChanged={this.onFilesChanged}
                    allowedFileTypes={this.props.widget.allowedFileTypes}
                    submission={this.props.submission}
                    widget={this.props.widget}
                    disabled={this.props.disabled}
                />
                <span>
                    <FormattedMessage id="submission.logo.allowedFileFypes"/>
                    {
                        // die key-Angabe ist notwendig, da React sonst meckert, dass jedes child einer Liste keys braucht
                        this.props.widget.allowedFileTypes ?
                            this.props.widget.allowedFileTypes.map((item, i) => <b key={i}> .{item}</b>) :
                            <b> keine</b>
                    }
                </span>
                <Form.Control.Feedback type="invalid">
                    {this.getError()}
                </Form.Control.Feedback>
                {this.getCustomRequiredError()}
            </Form.Group>
        );
    }
}

LogoUploadWidget.propTypes = {
    widget: PropTypes.object
};

export function type() {
    return 'logo_upload';
}

export function initialValue(widget) {
    return [];
}

/**
 * @param widget
 * @param allowPartialSubmissions
 * @returns {NotRequiredNullableArraySchema<object | undefined, object>}
 */
export function schema(widget, allowPartialSubmissions) {
    return yup.array().of(yup.object()).nullable();
}

export function component() {
    return LogoUploadWidget;
}
